export default "__VITE_ASSET__Brqq6ATO__"